import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { ButtonCTA } from './ButtonCTA';
export function OfferSection() {
  return <section id="oferta" className="py-20 md:py-32 bg-[#0f172a] relative overflow-hidden" data-id="element-90">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[500px] bg-amber-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-91"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-92">
        <div className="bg-gradient-to-b from-slate-800 to-slate-900 p-8 md:p-16 rounded-3xl border border-amber-500/30 shadow-2xl text-center" data-id="element-93">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6" data-id="element-94">
            Recupera la Paz y la Conexión en Tu Hogar
          </h2>

          <p className="text-xl text-slate-300 mb-12" data-id="element-95">
            Este sistema no cuesta lo que una sesión de terapia de pareja.
          </p>

          <div className="mb-10" data-id="element-96">
            <div className="inline-block bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 text-amber-400 font-semibold text-sm mb-4 uppercase tracking-wider" data-id="element-97">
              Inversión única
            </div>
            <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-98">
              <span className="text-3xl md:text-4xl font-bold text-slate-500 line-through" data-id="element-99">
                $19
              </span>
              <span className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-600" data-id="element-100">
                $9.50
              </span>
              <span className="text-2xl md:text-3xl font-bold text-slate-400 mt-4" data-id="element-101">
                USD
              </span>
            </div>
            <div className="inline-block mt-3 bg-red-500/20 border border-red-500/30 rounded-full px-4 py-1 text-red-400 font-semibold text-sm" data-id="element-102">
              50% de descuento — Oferta limitada
            </div>
            <p className="text-slate-400 mt-4" data-id="element-103">
              Obtén el Pack de Sistemas ADHD completo por una inversión única
              que transforma tu convivencia.
            </p>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-104">
            <ButtonCTA text="QUIERO DETENER LAS PELEAS HOY" className="w-full sm:w-auto text-xl py-5 px-10" data-id="element-105" />

            <div className="flex items-center gap-2 text-slate-400 text-sm md:text-base" data-id="element-106">
              <ShieldIcon className="w-5 h-5 text-teal-500" data-id="element-107" />
              <span data-id="element-108">
                Acceso inmediato. Descarga el material ahora mismo y empieza
                esta noche.
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}